/**
 * @desc 销售订单修改
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.CustomsDeclarationMasterRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationMaster/editForSaleOrder`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
